import classNames from "classnames";
import React from "react";

export const Box = ({ children, className }) => {
  return <div className={classNames("box", className)}>{children}</div>;
};
